import React, { useContext, useReducer } from "react";
import { useContextWarning } from "../util";
// store layers
const LayerContext = React.createContext(undefined);
const LAYER_PREFIX = "dna-";
/**
 * Simple context provider that keeps track of a deck.gl layer stack.
 */
export const DeckGLProvider = ({ children }) => {
    // const [layers, setLayers] = React.useState<any[]>([]);
    // LAYER_PREFIX is added to the layer ID so we can identify
    // it inside the mapbox instance
    const [layers, setLayers] = useReducer((state, action) => {
        // get the next state
        const next = typeof action === "function" ? action(state) : action;
        // loop through and add the prefix to the ID.
        // note: not sure this is good because immutable...
        return next.map((layer) => {
            if (!layer.id.includes(LAYER_PREFIX))
                layer.id = LAYER_PREFIX + layer.id;
            return layer;
        });
    }, []);
    return (React.createElement(LayerContext.Provider, { value: [layers, setLayers] }, children));
};
export default DeckGLProvider;
export const useDeckGL = () => {
    const context = useContext(LayerContext);
    useContextWarning(context, "DeckGLProvider");
    return context;
};
